module.exports = __webpack_public_path__ + "img/logo_sekulic2022-retina.74181aab.png";